var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-1" },
    [
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.client
                ? (_vm.client.otherName || "") +
                    " " +
                    (_vm.client.surname || "")
                : ""
            ) +
            " "
        ),
      ]),
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(" " + _vm._s(this.getAddress) + " "),
      ]),
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(" " + _vm._s(_vm.client.city) + " "),
      ]),
      _c("b-card-text", { staticClass: "mb-25" }, [
        _vm._v(" " + _vm._s(_vm.client ? _vm.client.tel : "") + " "),
      ]),
      _c("b-card-text", { staticClass: "mb-0" }, [
        _vm._v(" " + _vm._s(_vm.client ? _vm.client.email : "") + " "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }